import router from "./index";
import NProgress from "nprogress"; // Progress 进度条
import "nprogress/nprogress.css"; // Progress 进度条样式
// import { Message } from 'element-ui';

import Layout from "@/pages/layout/index";

import versionTood from '@/libs/versionUpdate'    //清除浏览器缓存
import {
  getStorageToken,
  getStorageAdminUser,
  setStorageCurrentMenu,
  getStorageUserIsLogin

} from "@/utils/store";
import store from "@/store";
import { vueComment } from "./config";
let roterList = [];
router.beforeEach((to, from, next) => {
  versionTood.isNewVersion();       ////判断当前代码版本是否与服务器中代码版本一致，如不一致则刷新页面获取最新
  NProgress.start();
  if (
    getStorageUserIsLogin()&& //此缓存有有效期，过期了重新登录
    getStorageToken() &&
    getStorageAdminUser().role_id &&
    store.state.app.menuList.length
  ) {
    let currentMenu = store.state.app.currentMenu;
    let menuList = store.state.app.menuList;
    let menuMapById = store.state.app.menuMapById;
    let menuMapByPathName = store.state.app.menuMapByPathName;
    if (to.path == "/") {
      let first = menuList[0].children[0].hideMenu
        ? menuList[0].children[1]
        : menuList[0].children[0];
      if (currentMenu.id != first.id || !to.meta.menuId) {
        store.dispatch("app/setOpenGroups", [menuList[0].id]);
        store.dispatch("app/setCurrentMenu", menuMapById[first.id]);
        setStorageCurrentMenu(Object.assign({}, menuMapById[first.id]));
        next({ path: first.path });
      } else {
        to.meta.menuId &&
          store.dispatch("app/chooseNavTab", {
            id: to.meta.menuId,
            title: to.meta.title,
            pid: to.meta.menuPid,
            path: to.meta.pathUrl,
            fullPath: to.fullPath,
          });
        next();
      }
    } else {
      if (to.meta.hideMenu && to.meta.name != to.meta.showMenuName) {
        let tid = menuMapByPathName[to.meta.showMenuName].id;
        store.dispatch("app/setOpenGroups", [
          menuMapByPathName[to.meta.showMenuName].parent_id,
        ]);
        store.dispatch("app/setCurrentMenu", menuMapById[tid]);
        setStorageCurrentMenu(Object.assign({}, menuMapById[tid]));
      } else {
        if (currentMenu.id != to.meta.menuId) {
          if (!to.meta.hideMenu && to.meta.menuId) {
            store.dispatch("app/setOpenGroups", [to.meta.menuPid]);
            store.dispatch("app/setCurrentMenu", menuMapById[to.meta.menuId]);
            setStorageCurrentMenu(
              Object.assign({}, menuMapById[to.meta.menuId])
            );
          }
        }
      }
      to.meta.menuId &&
        store.dispatch("app/chooseNavTab", {
          id: to.meta.menuId,
          title: to.meta.title,
          pid: to.meta.menuPid,
          path: to.meta.pathUrl,
          fullPath: to.fullPath,
        });
      next();
    }
  } else {
    if (to.path === "/login") {
      next();
    } else {
      next({ path: "/login" });
    }
  }
});

router.afterEach(() => {
  NProgress.done(); // 结束Progress
  document.documentElement.scrollTop = 0;
});

export const addRouters = (list) => {
  roterList = [];
  // let menuMapByName = {}
  list.map((group) => {
    if (!group.children.length) return;
    let g = {
      path: `/${group.url}`,
      component: Layout,
      redirect: `/${group.url}/${group.children[0].url}`,
      name: group.name,
      children: [],
    };
    group.children.map((menu) => {
      if (!menu.is_group) {
        if (vueComment[menu.pathName]) {
          g.children.push({
            path: menu.url,
            name: menu.pathName,
            component: vueComment[menu.pathName].comment,
            meta: {
              pathUrl: menu.path,
              hideMenu: menu.hideMenu,
              menuId: menu.id,
              showMenuName: vueComment[menu.pathName].showMenu || menu.pathName,
              menuPid: menu.parent_id,
              openUrl: vueComment[menu.pathName].openUrl || "",
              title: menu.name,
            },
          });
        }
      }else{
        menu.children && menu.children.length && menu.children.map(gmenu => {
          if (vueComment[gmenu.pathName]) {
            g.children.push({
              path: gmenu.url,
              name: gmenu.pathName,
              component: vueComment[gmenu.pathName].comment,
              meta: {
                pathUrl: gmenu.path,
                hideMenu: gmenu.hideMenu,
                menuId: gmenu.id,
                showMenuName: vueComment[gmenu.pathName].showMenu || gmenu.pathName,
                menuPid: gmenu.parent_id,
                openUrl: vueComment[gmenu.pathName].openUrl || "",
                title: gmenu.name,
              },
            });
          }
        })
      }
      // if (vueComment[menu.pathName]) {
      //   g.children.push({
      //     path: menu.url,
      //     name: menu.pathName,
      //     component: vueComment[menu.pathName].comment,
      //     meta: {
      //       pathUrl: menu.path,
      //       hideMenu: menu.hideMenu,
      //       menuId: menu.id,
      //       showMenuName: vueComment[menu.pathName].showMenu || menu.pathName,
      //       menuPid: menu.parent_id,
      //       openUrl: vueComment[menu.pathName].openUrl || "",
      //       title: menu.name,
      //     },
      //   });
      // }
    });
    roterList.push(g);
  });
  // vue-router新版本下，router.addRoutes已被废弃；使用 route.addRoute() 代替
  router.addRoutes(roterList);
  // router.addRoute(...roterList);
};
